export default __webpack_public_path__ + "static/media/ier-logo2.4a1a2341.png";